import request from '@/utils/request';
import { apiBaseProd } from '../../../config/custom';

export async function getCollection(params) {
  return request(`${apiBaseProd}/newApp/product/1.0.0/getCollectionProducts`, {
    params,
  });
}
